import MultipleWidgetContainer from './MultipleWidgetContainer.component';
export default MultipleWidgetContainer;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/MultipleWidgetContainer/index.js